export default {
  install (Vue) {
    // 防止重复点击 默认3s
    Vue.directive('preventReClick', {
      inserted (el, binding) {
        el.addEventListener('click', () => {
          if (!el.disabled) {
            el.disabled = true
            el.className = el.className + " is-disabled";
            setTimeout(() => {
              el.disabled = false
              el.className = el.className.split("is-disabled")[0];
            }, binding.value || 1000)
          }
        })
      }
    })
  }
}
